module.exports = __webpack_public_path__ + "img/Terrasse.d975ffda.jpg";